$("ul[class='policy-tree'] li ul").hide();

$("ul[class='policy-tree'] li").on("click", function (e) {
    e.stopPropagation();
    $(this).children('ul').toggle();
});

function uuidv4() {
    //Returns Close to Unique Id
    var uid = ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c => (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16));
    return uid;
}

function isEmptyOrSpaces(str) {
    return str === null || str.match(/^ *$/) !== null;
}

var treeViewDataTag = function () {
    this.key = "";
    this.value = "";

    return {
        key: this.key,
        value: this.value
    };
};

var treeViewNode = function () {
    this.value = "";
    this.id = "";
    this.type = "";
    this.class = "";
    this.canHaveChildren = false;
    this.isEmpty = false;
    this.children = [];
    this.dataTags = [];
    this.allowSelection = false;

    this.loadDataCallback = null;
    this.selectItemCallback = null;

    return {
        value: this.value,
        id: this.id,
        type: this.type,
        class: this.class,
        canHaveChildren: this.canHaveChildren,
        isEmpty: this.isEmpty,
        loadDataCallback: this.loadDataCallback,
        selectItemCallback: this.selectItemCallback,
        children: this.children,
        dataTags: this.dataTags,
        allowSelection: this.allowSelection
    };
};

function treeView(controlId, allowSelection, loadDataAsync, loadDataCallback, selectItemCallback) {
    //TODO: Add setting to start tree as expanded or not (not possible for loadDataAsync)
    //TODO: Convert to library call and initialization with settings
    var container = $("#" + controlId);
    this.allowSelection = allowSelection;
    this.loadDataAsync = loadDataAsync;

    //TODO: if needed add data source to tree with prefilled nodes
    generateTreeNode(container, null, this.allowSelection, this.loadDataAsync, loadDataCallback, selectItemCallback);
}

function loadTreeNodeData(container, loadDataAsync, loadDataCallBack) {
    var data = loadDataAsync(container);

    return data;
}

function generateTreeNode(container, treeNode, allowSelection, loadDataAsync, loadDataCallback, selectItemCallback) {

    //Generates node html from template
    var node = "<div id=\"{{uid}}\" class=\"{{class}}\" data-id=\"{{id}}\" role=\"button\" {{actions}} {{datatags}}>{{value}}</div>{{childWrapper}}";
    var actions = " data-bs-toggle=\"collapse\" data-bs-target=\"#{{childId}}\"";
    var childWrapper = "<div class=\"policy-tree inner-wrapper collapse in\" id=\"{{childUid}}\" data-id=\"{{id}}\"></div>";
    var nodeUid = uuidv4();
    var childUid = uuidv4();

    //Clear Items from container
    if (container.prop("id") == "policy-tree") {
        nodeUid = "policy-tree";
        container.empty();
        container.next('.policy-tree.inner-wrapper').remove();
    }
    //Clear Items from container

    //Load node data if no node was passed
    if (!treeNode || treeNode.isEmpty) {

        var data = loadDataCallback(container);

        if (data.isEmpty) { return; }

        treeNode = data;
        if (!treeNode.loadDataCallback) {
            //Node doesn't have specific loadDataCallback - setting to default
            treeNode.loadDataCallback = loadDataCallback;
        }
        if (!treeNode.selectItemCallback) {
            //Node doesn't have specific selectDataCallback - setting to default
            treeNode.selectItemCallback = selectItemCallback;
        }
    }

    node = node.replace("{{uid}}", nodeUid);
    node = node.replace("{{class}}", "tree-view--item " + treeNode.class);
    node = node.replace("{{id}}", treeNode.id);
    node = node.replace("{{value}}", treeNode.value);

    //Adding value and isEmpty data tags
    var valueTag = new treeViewDataTag();
    valueTag.key = "value";
    valueTag.value = treeNode.value;
    var isEmptyTag = new treeViewDataTag();
    isEmptyTag.key = "isempty";
    isEmptyTag.value = treeNode.isEmpty;
    treeNode.dataTags.push(valueTag);
    treeNode.dataTags.push(isEmptyTag);

    var tags = "";
    for (var j = 0; j < treeNode.dataTags.length; j++) {
        tags = tags + "data-" + treeNode.dataTags[j].key + "=\"" + treeNode.dataTags[j].value + "\" ";
    }
    node = node.replace("{{datatags}}", tags);

    //making sure that canHaveChildren is set to true if children are already loaded
    if (treeNode.children.length > 0) { treeNode.canHaveChildren = true; }

    if (treeNode.canHaveChildren) {
        actions = actions.replace("{{childId}}", childUid);
        node = node.replace("{{actions}}", actions);
        childWrapper = childWrapper.replace("{{childUid}}", childUid);
        childWrapper = childWrapper.replace("{{id}}", treeNode.id);
        node = node.replace("{{childWrapper}}", childWrapper);
    } else {
        node = node.replace("{{actions}}", "");
        node = node.replace("{{childWrapper}}", "");
    }

    container.replaceWith(node);
    $("#" + nodeUid).off("click");

    if (treeNode.children && treeNode.children.length > 0) {
        //Node has loaded children adding them
        for (var i = 0; i < treeNode.children.length; i++) {
            // Creating Child wrapper
            var currentChild = uuidv4();
            $("#" + childUid).append("<div id=\"" + currentChild + "\"></div>");
            generateTreeNode($("#" + currentChild), treeNode.children[i], allowSelection, loadDataAsync, treeNode.children[i].loadDataCallback, treeNode.children[i].selectItemCallback);
        }
    }

    if (treeNode.canHaveChildren && (!treeNode.children || treeNode.children.length === 0) && !loadDataAsync) {
        //Data should be loaded right away
        if (treeNode.loadDataCallback) {
            //Has specific loadDataCallback
            generateTreeNode($("#" + nodeUid), null, allowSelection, loadDataAsync, treeNode.loadDataCallback, selectItemCallback);
        } else {
            //Use normal loadDataCallback
            generateTreeNode($("#" + nodeUid), null, allowSelection, loadDataAsync, loadDataCallback, selectItemCallback);
        }
    }
    //Bind the selection callback
    if (selectItemCallback) {
        $("#" + nodeUid).off("click").on("click", selectItemCallback);
    }
    if (loadDataAsync && treeNode.canHaveChildren && (!treeNode.children || treeNode.children.length === 0)) {
        //Data should be loaded only once requested
        $("#" + nodeUid).off("click").on("click", function () {
            if (treeNode.loadDataCallback) {
                //Has specific loadDataCallback
                generateTreeNode($("#" + nodeUid), null, allowSelection, loadDataAsync, treeNode.loadDataCallback, selectItemCallback);
            } else {
                //Use normal loadDataCallback
                generateTreeNode($("#" + nodeUid), null, allowSelection, loadDataAsync, loadDataCallback, selectItemCallback);
            }
        });
    }
}

$("div[class='tree-view--item']").on("click", function (e) {
    e.stopPropagation();
    $(this).children('div[class=\"tree-view--collapse--wrapper\"]').toggle();
});